export default __webpack_public_path__ + "static/invisi-v-14c977dd50218e74d97527c43a79eb0d.jpg";